export const STORAGE_NAME = "paris-events";

// Coordonnées publiées sur les pages légales et dans le pied de page.
export const CONTACT_EMAIL = "contact@sinaysenera.dev";
export const PORTFOLIO_URL = "https://sinaysenera.dev/";

// Source des événements.
export const DATA_SOURCE_URL =
  "https://opendata.paris.fr/explore/dataset/que-faire-a-paris-/information/";

// À remettre à jour en même temps que le contenu des pages légales.
export const LEGAL_UPDATED = "15 octobre 2026";
